import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function ProgramPhases() {
  const phases = [{
    phase: 'FAZA 1',
    modules: 'Modulele 1 și 2',
    name: 'AWARENESS',
    title: 'Vezi realitatea așa cum este, fără distorsiuni',
    points: ['Identifici unde ești cu adevărat și care este diferența dintre viața funcțională și viața autentică', 'Descoperi tiparele și condiționările care te-au ghidat fără să le vezi', 'Ieși din autoiluzie și înțelegi "programul" după care ai trăit până acum']
  }, {
    phase: 'FAZA 2',
    modules: 'Modulele 3 și 4',
    name: 'RELEASE',
    title: 'Eliberezi ce te ține blocată',
    points: ['Lucrezi cu emoțiile reprimate și reacțiile automate care te consumă', 'Înțelegi loialitățile invizibile și tiparele pe care le-ai moștenit din familie', 'Reduci încărcătura emoțională acumulată și vezi de unde vin de fapt blocajele tale']
  }, {
    phase: 'FAZA 3',
    modules: 'Modulele 5 și 6',
    name: 'IDENTITY',
    title: 'Reconstruiești cine ești dincolo de roluri',
    points: ['Redescoperi valorile tale reale, nu cele impuse de alții sau de context', 'Lucrezi pe stima de sine și pe capacitatea de a pune limite sănătoase', 'Începi să te alegi pe tine, fără vinovăție și fără să ceri voie']
  }, {
    phase: 'FAZA 4',
    modules: 'Modulele 7 și 8',
    name: 'SYSTEM ALIGNMENT',
    title: 'Reașezi relațiile și viața din exterior',
    points: ['Clarifici dinamica din cuplu, familie și relațiile importante din viața ta', 'Lucrezi pe cariera ta și pe relația cu banii, din poziția cine ești cu adevărat', 'Construiești relații mai sănătoase și mai conștiente, pornind de la locul tău real']
  }, {
    phase: 'FAZA 5',
    modules: 'Modulul 9',
    name: 'EMBODIMENT',
    title: 'Trăiești noua identitate în viața reală',
    points: ['Integrezi tot procesul și îl transformi în decizii concrete', 'Construiești un plan de viață aliniat cu cine ești acum', 'Nu mai înțelegi doar diferit, începi să trăiești diferit']
  }];
  return <section className="py-20 md:py-28 bg-ivory relative overflow-hidden" data-id="element-749">
      <div className="max-w-[1000px] mx-auto px-6 md:px-8 relative z-10" data-id="element-750">
        <div className="text-center mb-16" data-id="element-751">
          <FadeIn data-id="element-752">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-forest mb-6" data-id="element-753">
              Cele 5 faze prin care trecem împreună în 9 luni
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-8" data-id="element-754">
          {phases.map((phase, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-755">
              <div className="bg-white border border-gold/30 rounded-[24px] p-8 md:p-10 shadow-soft hover:shadow-lg transition-shadow duration-300 relative overflow-hidden group" data-id="element-756">
                {/* Subtle decorative number */}
                <div className="absolute -right-4 -top-8 text-[120px] font-serif font-bold text-gold/5 group-hover:text-gold/10 transition-colors duration-300 pointer-events-none" data-id="element-757">
                  {index + 1}
                </div>

                <div className="flex flex-col md:flex-row gap-6 md:gap-12 relative z-10" data-id="element-758">
                  {/* Left Column - Phase Info */}
                  <div className="md:w-1/3 shrink-0" data-id="element-759">
                    <div className="inline-block border border-forest/20 rounded-full px-4 py-1 mb-4 bg-forest/5" data-id="element-760">
                      <span className="font-display text-xs font-semibold tracking-wider text-forest uppercase" data-id="element-761">
                        {phase.phase} • {phase.modules}
                      </span>
                    </div>
                    <h3 className="text-2xl font-serif font-medium text-forest mb-2" data-id="element-762">
                      {phase.name}
                    </h3>
                    <p className="text-[18px] font-medium text-charcoal/80" data-id="element-763">
                      {phase.title}
                    </p>
                  </div>

                  {/* Right Column - Points */}
                  <div className="md:w-2/3" data-id="element-764">
                    <ul className="space-y-4" data-id="element-765">
                      {phase.points.map((point, ptIndex) => <li key={ptIndex} className="flex items-start gap-4" data-id="element-766">
                          <div className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center shrink-0 mt-1" data-id="element-767">
                            <Check className="w-3.5 h-3.5 text-gold-dark" strokeWidth={3} data-id="element-768" />
                          </div>
                          <p className="text-[18px] text-charcoal/70 leading-relaxed" data-id="element-769">
                            {point}
                          </p>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}